"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require('./justgage.component'));
__export(require('./justgage.module'));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-justgage/dist/index.js
// module id = 184
// module chunks = 3